<template>
  <div class="navigation">
    <div id="nav">
      <div class="link-element">
        <img class="logo-wrap" src="../assets/Bookmark-Spanish-Logo-250-minuscom.png" alt="BookmarkSpanish.com">
      </div>
      <div class="link-wrapper">
        <div v-on:click="goToApp" class="link-element link-element-login">
          Login
        </div>
        <!-- <router-link class="link-element" to="/booklist">
          Library
        </router-link> -->
        <!-- <router-link to="/bookinfo">Bookinfo</router-link> |
        <router-link to="/book">Book</router-link> | -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Navigation',
  components: {
  },
  methods:{
    goToApp: function () {   
      window.open("https://app.bookmarkspanish.com", "_blank")
    }
  }
}
</script>

<style scoped>
.link-wrapper {
  display: flex;
  margin-right: 10px;
}
.logo-wrap {
  margin-left: 5px;
  height: 45px;
  justify-self: flex-end;
}
.link-icon-book {
  margin-left: 10px;
  background-repeat: no-repeat;
  width: 25px;
  /* height: 25px; */
}
.link-element {
  display: flex;
  justify-content: center;
  align-self: center;
  margin: 0 10px 0 10px;
  color: #afafaf;
}
.link-element-login {
  cursor: pointer;
  font-weight: 500;
}
#nav {
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 15px;
  /* height: 60px; */
  /* position: fixed; */
  top: 0;
  width: calc(100% - 30px);
  /* border-bottom: 1px solid #e5e5e5; */
  background-color: white;
}

#nav a {
  text-decoration: none;
  font-weight: bold;
}

#nav a.router-link-exact-active {
  /* color: #42b983; */
  color: #2c3e50;
}
.logout-btn {
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
}
</style>
